export const GET_PACKAGES_FOR_ROOM_UPGRADE = 'GET_PACKAGES_FOR_ROOM_UPGRADE';
export const GET_PACKAGES_FOR_ROOM_UPGRADE_SUCCESS =
  'GET_PACKAGES_FOR_ROOM_UPGRADE_SUCCESS';
export const GET_PACKAGES_FOR_ROOM_UPGRADE_FAIL =
  'GET_PACKAGES_FOR_ROOM_UPGRADE_FAIL';
export const CHECK_EXTRA_ROOM_REQUEST = 'CHECK_EXTRA_ROOM_REQUEST';

export const TIMEOUT = 90 * 1000; // 90 sec
